import{FeatureFlagContext as e}from"../FeatureFlagProvider.js";import{useContext as r}from"react";var a=a=>!!r(e)[a];export{a as useFeatureFlag};
//# sourceMappingURL=useFeatureFlag.js.map